<template>
	<div id="content" class="content mypage">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">나의 구매</h2>
			</div>

			<div class="payment-state-list">
				<ul v-for="item in paymentInfo">
					<li v-if="item.OrderGoods.content.length !== 0">
						<a :href="'/mypage/paymentDetail/' + item.OrderInfo.oid + ''">
							<div class="date-wrap">
								{{ item.OrderGoods.content[0].createDate | dateFilter }}
							</div>
							<div class="goods-wrap">
								<div class="thumb-box" v-if="item.OrderGoods.content[0].goodsVO.thumbIdx !== null" :style="'background-image:url(' + APIs.SHOP_FILE_SHOW + item.OrderGoods.content[0].goodsVO.thumbIdx + ');'"/>
								<div class="thumb-box" v-else style="background-image: url(public/ssflex/assets/hws-images/icons8-color-64.png);"/>
								<div class="text-box">
									<h2 class="tit">
										{{ item.OrderGoods.content[0].goodsVO.title }} <template v-if="item.OrderGoods.content.length > 1"> 외 {{ item.OrderGoods.content.length - 1}}개</template>
									</h2>
								</div>
								<div class="info-box">
									<div class="info-row">
										<strong>주문번호</strong>
										<div>{{ item.OrderInfo.oid }}</div>
									</div>
									<div class="info-row">
										<strong>결제금액</strong>
										<div>{{ item.OrderInfo.orderPrice | currency }}원</div>
									</div>
									<div class="info-row">
										<strong>주문상태</strong>
										<div>{{ item.OrderInfo.stat === 1 ? "주문(결제 진행중)" :
												item.OrderInfo.stat === 2 ? "결제완료" :
												item.OrderInfo.stat === 3 ? "입금확인중" :
												item.OrderInfo.stat === 4 ? "결제실패" :
												item.OrderInfo.stat === 5 ? "PAY요청중" :
												item.OrderInfo.stat === 8 ? "주문확인" :
												item.OrderInfo.stat === 10 ? "배송준비중" :
												item.OrderInfo.stat === 11 ? "배송중" :
												item.OrderInfo.stat === 13 ? "배송완료" :
												item.OrderInfo.stat === 30 ? "교환" :
												item.OrderInfo.stat === 31 ? "교환요청" :
												item.OrderInfo.stat === 32 ? "교환철회 요청" :
												item.OrderInfo.stat === 33 ? "교환회수중" :
												item.OrderInfo.stat === 34 ? "판매자 전달완료(교환)" :
												item.OrderInfo.stat === 35 ? "교환완료" :
												item.OrderInfo.stat === 40 ? "반품" :
												item.OrderInfo.stat === 41 ? "반품요청" :
												item.OrderInfo.stat === 42 ? "반품철회 요청" :
												item.OrderInfo.stat === 43 ? "반품회수중" :
												item.OrderInfo.stat === 44 ? "판매자 전달완료(반품)" :
												item.OrderInfo.stat === 45 ? "반품완료" :
												item.OrderInfo.stat === 50 ? "회수중" :
												item.OrderInfo.stat === 51 ? "판매자 전달완료" :
												item.OrderInfo.stat === 52 ? "환불완료" :
												item.OrderInfo.stat === 65 ? "취소요청" :
												item.OrderInfo.stat === 66 ? "취소 철회요청" :
												item.OrderInfo.stat === 68 ? "취소완료" :
												item.OrderInfo.stat === 90 ? "구매확정" : "Err"}}</div>
									</div>
								</div>
							</div>
						</a>
					</li>
				</ul>
			</div>
			<!-- 버튼 -->
			<div class="btn-area" v-if="count <= paymentInfo.length">
				<a href="javascript:;" class="btn-loadmore" @click="doLoadMore">LOAD MORE</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "paymentState",
	data() {
		var params = this.pageUtils.Params()
		if (this.webUtils.getParameterInt("idx") > 0) {
			params.idx = this.webUtils.getParameterInt("idx");
		}
		return {
			params,
			count: 0,
			pageCount: 3,
			paymentInfo: [],
		}
	},
	async created() {
		await !this.requireLogin(this, false);
	},
	mounted() {
		this.getPaymentInfo();
	},
	methods: {
		getPaymentInfo() {
			this.axiosCaller.get(this, this.APIs.SHOP_ORDER + "/getPaymentInfo", {
				uid: this.getSessionProc().coEmailId,
				page: this.params.page,
				size: this.pageCount,
				sort: this.params.sort,
			}, (r) => {
				if (r.data.status === "ok") {
					this.count = r.data.count;
					this.paymentInfo = r.data.result;
					console.log(this.paymentInfo)
					console.log(this.count)
				} else {
					this.swalUtils.gritter("Error", r.data.msg, "error")
							.then(() => {
								location.href = document.referrer
							})
				}
			})
		},
		doLoadMore() {

			this.params.page++;
			this.pageUtils.routerPush( this, this.params )

			this.getPaymentInfo();

		},
	}
}
</script>

<style scoped>

</style>
